module.exports = __webpack_public_path__ + "static/media/next.5260fd48.svg";